var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('v-card',{staticClass:"elevation-3 pa-1 mb-6"},[_c('v-sheet',[_c(this.context ? _vm.context : 'div',{tag:"component"},[_vm._v(_vm._s(!this.context ? 'Select Tool' : ''))])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }